import { createContext } from "react";
import type { ChangeEventLike } from "@/util/localStorageConfig.ts";

export const defaultTwitchConfig = {
  twitchUsername: "",
  twitchAccessToken: "",
  twitchRefreshToken: "",
  twitchBroadcasterID: "",
  twitchCampaignID: "",
  twitchCampaignGoal: "0.00",
  twitchCampaignName: "",
};

export type TwitchConfig = typeof defaultTwitchConfig;

export interface TwitchConfigContextValue {
  config: TwitchConfig;
  setField: <K extends keyof TwitchConfig>(key: K, value: TwitchConfig[K]) => void;
  setFromEvent: (e: ChangeEventLike) => void;
  clearField: (key: keyof TwitchConfig) => void;
}

export const TwitchConfigContext = createContext<TwitchConfigContextValue>({
  config: defaultTwitchConfig,
  setField: () => {},
  setFromEvent: () => {},
  clearField: () => {},
});
